import { useState } from 'react';
import type { SessionStorageValue } from '@/shared/lib/storage';
import { getSessionStorage, setSessionStorage } from '@/shared/lib/storage';

type OverrideValue = SessionStorageValue<'debug-role-override'>;

/**
 * ユーザーロールのオーバーライドを管理するフック
 * デバッグ用にロール（admin / editor）を切り替えてUI挙動を確認するために使用する
 * セッションストレージに状態を保存
 */
export const useRoleOverride = () => {
  const [overrideValue, setOverrideValue] = useState<OverrideValue>(() =>
    getSessionStorage('debug-role-override'),
  );

  const updateOverrideValue = (value: OverrideValue) => {
    setOverrideValue(value);
    setSessionStorage('debug-role-override', value);
  };

  return {
    overrideValue,
    updateOverrideValue,
  };
};
